@if ((solutionSpace$ | async); as solutionSpace) {
<app-component-insights
  [solutionSpace]="solutionSpace"
  [datalogsHumidity$]="datalogsHumidity$"
  [datalogsNSE$]="datalogsNSE$"
  (updateDateRangeHumidity)="updateDateRangeHumidity($event)"
  (updateDateRangeNSE)="updateDateRangeNSE($event)"
>
</app-component-insights>
}
